// CertFilters.jsx 🧠🔍 Filtres CERT – alignés au pixel près avec IoC
import React from "react";
import "./styles/CertView.css";

const CertFilters = ({
  filters,
  handleChange,
  resetFilters,
  handleSearch,
  handleCollapseReset,
  searchQuery,
  totalCount,
  totalAll
}) => {
  return (
    <div className="filter-container cert-wrapper mb-4">
      {/* 🔹 HEADER TOUT À DROITE */}
      <div className="d-flex justify-content-end align-items-center flex-wrap gap-2 mb-3">
        {/* Count */}
        {typeof totalCount !== "undefined" && (
          <span className="filter-title-cert" id="certCount">
            {totalCount} of {totalAll} CERT Alerts
          </span>
        )}

        {/* Search bar */}
        <form onSubmit={(e) => e.preventDefault()} className="d-flex">
          <div className="input-group" style={{ minWidth: "280px" }}>
            <input
              id="searchQueryCert"
              type="text"
              name="searchQuery"
              value={searchQuery}
              onChange={handleSearch}
              className="form-control"
              placeholder="Search vuln, vendor, tags..."
              autoComplete="off"
            />
          </div>
        </form>

        {/* Reset buttons */}
        <button
          id="reset-filters-cert"
          onClick={resetFilters}
          className="btn btn-reset"
          title="Reset filters"
        >
          <i className="bi bi-arrow-clockwise"></i>
        </button>

        {handleCollapseReset && (
          <button
            id="reset-collapses-cert"
            onClick={handleCollapseReset}
            className="btn btn-collapse-reset"
            title="Reset collapses"
          >
            <i className="bi bi-x-square"></i>
          </button>
        )}
      </div>

      {/* 🔸 FILTERS GRID */}
      <div className="filter-grid-cert">
        <div className="filter-item form-check d-flex align-items-center">
          <input
            className="form-check-input"
            type="checkbox"
            id="exploited"
            name="exploited"
            checked={filters.exploited}
            onChange={handleChange}
          />
          <label className="form-check-label ms-2" htmlFor="exploited">
            Exploited
          </label>
        </div>

        <div className="filter-item form-check d-flex align-items-center">
          <input
            className="form-check-input"
            type="checkbox"
            id="alerte"
            name="alerte"
            checked={filters.alerte}
            onChange={handleChange}
          />
          <label className="form-check-label ms-2" htmlFor="alerte">
            Proof of Concept
          </label>
        </div>

        <div className="filter-item form-check d-flex align-items-center">
          <input
            className="form-check-input"
            type="checkbox"
            id="workaround"
            name="workaround"
            checked={filters.workaround}
            onChange={handleChange}
          />
          <label className="form-check-label ms-2" htmlFor="workaround">
            Workaround
          </label>
        </div>

        <div className="filter-item form-check d-flex align-items-center">
          <input
            className="form-check-input"
            type="checkbox"
            id="resolved"
            name="resolved"
            checked={filters.resolved}
            onChange={handleChange}
          />
          <label className="form-check-label ms-2" htmlFor="resolved">
            Resolved
          </label>
        </div>

        <div className="filter-item form-check d-flex align-items-center">
          <input
            className="form-check-input"
            type="checkbox"
            id="user_tags"
            name="user_tags"
            checked={filters.user_tags}
            onChange={handleChange}
          />
          <label className="form-check-label ms-2" htmlFor="user_tags">
            My Tags
          </label>
        </div>

        <div className="filter-item-date">
          <select
            id="filterTimeRangeCert"
            name="time_range"
            className="form-select"
            value={filters.time_range}
            onChange={handleChange}
          >
            <option value="">All Time</option>
            <option value="1">Last 24 Hours</option>
            <option value="7">Last 7 Days</option>
            <option value="30">Last 30 Days</option>
            <option value="90">Last 90 Days</option>
            <option value="180">Last 6 Months</option>
            <option value="365">Last Year</option>
          </select>
        </div>

        <div className="filter-item-date">
          <select
            id="filterAffectedCountryCert"
            name="affected_country"
            className="form-select"
            value={filters.affected_country}
            onChange={handleChange}
          >
            <option value="">Affected Country</option>
            <option value="FR">🇫🇷 France</option>
            <option value="DE">🇩🇪 Germany</option>
            <option value="IT">🇮🇹 Italy</option>
            <option value="ES">🇪🇸 Spain</option>
            <option value="US">🇺🇸 USA</option>
            <option value="Unknown">🌍 World</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default CertFilters;
